export default {
    init() {
        // Initial count of visible posts
        let visibleCount = 4;

        // Function to show more posts
        function showMorePosts() {
            // Select hidden posts after the visible ones
            const hiddenPosts = $('.posts__postpreview.hidden').slice(0, 4);

            // Show hidden posts
            hiddenPosts.removeClass('hidden');

            // Update the count of visible posts
            visibleCount += hiddenPosts.length;

            // If there are no more hidden posts, hide the "Load More" button
            if ($('.posts__postpreview.hidden').length === 0) {
                $('.alm-load-more-btn').hide();
            }
        }

        // Initial click event for "Load More" button
        $('body').on('click', '.alm-load-more-btn', function (event) {
            event.preventDefault();
            showMorePosts();
        });
    },
};



// WEBPACK FOOTER //
// ./scripts/components/load-more.js